import { faPen, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { Button, Card, CardBody } from 'reactstrap';

import { Days, Months } from 'src/util/constants';

import TimeOfUsable from 'src/components/TradeRule/TimeOfUse/TimeOfUsable';

/**
 * Description
 * @param {any} props
 * @returns {React.ReactComponentElement} - ClauseShow component
 */
function ClauseShow(props) {
  const {
    clause, showControls, editClause, removeClause,
  } = props;

  const style = clause.price ? {} : { border: '1px solid red' };

  return (
    <Card style={style} className="mb-1">
      <CardBody className="d-flex">
        <div>
          <TimeOfUsable
            timeOfUsable={clause}
            showConditions
            oneLiner
          />
        </div>
        {showControls && (
          <div className="ms-auto flex-shrink-0">
            <Button color="" onClick={editClause}>
              <FontAwesomeIcon icon={faPen} />
            </Button>
            <Button color="" onClick={removeClause}>
              <FontAwesomeIcon icon={faTimes} />
            </Button>
          </div>
        )}
      </CardBody>
    </Card>
  );
}

const timeOfDayShape = PropTypes.shape({
  hours: PropTypes.number,
  minutes: PropTypes.number,
  seconds: PropTypes.number,
  nanos: PropTypes.number,
});

ClauseShow.propTypes = {
  clause: PropTypes.shape({
    price: PropTypes.number,
    monthsOfYear: PropTypes.arrayOf(PropTypes.oneOf(Months)),
    daysOfWeek: PropTypes.arrayOf(PropTypes.oneOf(Days)),
    timesOfDay: PropTypes.arrayOf(PropTypes.shape({
      start: timeOfDayShape,
      finish: timeOfDayShape,
    })),
  }).isRequired,
  showControls: PropTypes.bool.isRequired,
  editClause: PropTypes.func.isRequired,
  removeClause: PropTypes.func.isRequired,
};

export default ClauseShow;
